import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';
import { stripe } from '../../../lib/stripe';
import { CREATE_IDENTITY_VERIFICATION_MUTATION } from '../../../graphql/stripe/identity/createIdentityVerificationSession';
import { useAuth } from '../../../lib/auth';

export const IdentityAgeReverifyPopup = () => {
  const { t } = useTranslation();
  const { getCurrentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [createVerificationSession] = useMutation(CREATE_IDENTITY_VERIFICATION_MUTATION);

  const handleStart = async () => {
    setLoading(true);
    try {
      const { data: { createVerificationSession: client_secret } } = await createVerificationSession();
      const result = await stripe?.verifyIdentity(client_secret);
      if (result?.error) console.log('error', result.error);
    } catch (err) {
      console.log(err);
    } finally {
      await getCurrentUser();
      setLoading(false);
    }
  };

  return (
    <div className="absolute bg-white z-status-popup left-[36px] right-[36px] top-[32px] shadow-lg flex flex-col p-6">
      <div className="text-lg text-center text-primary font-bold">
        {t('identityAgeReverifyPopup.title')}
      </div>
      <div className="my-4 text-sm text-center text-gray-600">
        {t('identityAgeReverifyPopup.body')}
      </div>
      <Button className="text-sm" type="primary" onClick={handleStart} disabled={loading}>
        {t('identityAgeReverifyPopup.start')}
      </Button>
    </div>
  );
};
